import { useTranslations } from 'next-intl'
import { ChangeEvent } from 'react'

import { Card } from '@/entities/contract'
import { Textarea } from '@/shared/ui'

type Props = {
  comment: string
  onCommentChange: (comment: string) => void
}

export const ToHostComment = ({ comment, onCommentChange }: Props) => {
  const t = useTranslations()

  const handleCommentChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onCommentChange(event.target.value)
  }

  return (
    <Card.Root spacing="large">
      <Card.Item>
        <Card.ItemTitle className="w-[140px] whitespace-break-spaces">
          {t('lease_request.landlord_message.title')}
        </Card.ItemTitle>
        <Card.ItemContent className="space-y-3">
          <p className="typo-label1 font-medium text-gray-900">
            {t('lease_request.landlord_message_description')}
          </p>
          <Textarea
            name="toHost"
            value={comment}
            maxLength={500}
            onChange={handleCommentChange}
            placeholder={t(
              'lease_request.landlord_message_message_input_placeholder',
            )}
            className="h-32"
            useCount
          />
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
